export default __webpack_public_path__ + "static/media/email-success.d1b9cadb.svg";